import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TabletModeService } from 'app/services/tablet-mode.service';

export const TabletEntryGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const tabletModeService = inject(TabletModeService);

  if (state.url.startsWith('/tablet/sign-in')) {
    return true;
  }

  const enterpriseId = route.queryParamMap.get('enterpriseId');
  if (!enterpriseId) {
    return router.parseUrl('/sign-in');
  }

  if (!tabletModeService.canAccessTabletSignIn(enterpriseId)) {
    return router.parseUrl('/sign-in');
  }

  return true;
};
